// Chặn ký tự đặc biệt nguy hiểm
const DANGEROUS_CHARS = /[<>{}[\]\\;`&]/g;

export const sanitizeInput = (value) => {
  if (!value || typeof value !== 'string') return value;
  return value.replace(DANGEROUS_CHARS, '');
};

export const validateEmail = (email) => {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  if (!phone) return true; // Cho phép để trống
  const phoneRegex = /^[0-9]{10,11}$/;
  return phoneRegex.test(phone);
};

export const validateTen = (ten) => {
  if (!ten || ten.trim().length === 0) return false;
  return true;
};

export const validatePassword = (password) => {
  if (!password || password.length < 6) return false;
  if (password === '123456') return false;
  return true;
};